import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import appSelectors from '@/redux/app/appSelectors';
import faqSelectors from '@/redux/faq/faqSelectors';

import faqOperations from '@/redux/faq/faqOperations';

import s from './faqList.module.css';

function FaqList({ tag }) {
  const dispatch = useDispatch();

  const lang = useSelector(appSelectors.language);
  const list = useSelector(faqSelectors.list);

  const [visibleId, setVisibleId] = useState(null);

  useEffect(() => {
    if (!list[tag]?.length) dispatch(faqOperations.getFaq(tag));
  }, [dispatch, list, tag]);

  return (
    <ul className={s.faq_list}>
      {list[tag]?.length > 0 &&
        list[tag].map(
          ({ id, title_en, title_ru, description_en, description_ru }) => (
            <li key={id}>
              <button
                type="button"
                onClick={() => setVisibleId(id === visibleId ? null : id)}
              >
                {lang === 'en' ? title_en : title_ru}
                <div className={id === visibleId ? s.minus : s.plus} />
              </button>
              <div
                dangerouslySetInnerHTML={{
                  __html: lang === 'en' ? description_en : description_ru,
                }}
                className={id === visibleId ? s.answer : s.answer_hidden}
              />
            </li>
          ),
        )}
    </ul>
  );
}

export default FaqList;

FaqList.propTypes = {
  tag: PropTypes.string.isRequired,
};
